module.exports = __webpack_public_path__ + "static/steven-69e7dad98c26b245de225e728a8cbd6f.jpeg";